// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1XbEj","col":"styles_col__2eSTW"};